<div class="credit-card">    
    <div class="card-container">
        <div #cardInfo></div>
    </div>       
</div>